import router from "@/router";
import {setPageTitle} from "@/shared/services/helper/utils";
import {GuardStore} from "@/guards/store";
import {AuthStore} from "@/modules/auth/store";
import { isEmpty } from "lodash";
import { notification } from "ant-design-vue";

const ignoreList = ["/auth/login", "/auth/register"];
router.beforeEach(async (to, from, next) => {
    setPageTitle(to?.meta?.title);
    if (AuthStore.token) {
        if (to.name === "login")
            return next({ name: "home" });
        if (!AuthStore.user || isEmpty(AuthStore.user)) {
            try {
                await AuthStore.userData();
            } catch (e) {
                AuthStore.logout();
                return;
            }
        }
        // check role users, generate routes by role, use for sidebar
        if (!GuardStore.routes.length) {
            GuardStore.generateRoutes(AuthStore.permissions);
        }
        if (to.meta?.role && !AuthStore.permissions.includes(to.meta.role)) {
            notification.warning({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        next();
    } else {
        console.log(ignoreList.indexOf(to.path));
        if (ignoreList.indexOf(to.path) !== -1) {
            next();
        } else {
            next({ name: "login" })
        }
    }
});
